import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        site: '<',
        tree: '<'
    },
    template: `
        <form ng-submit="vm.save()">
            <form-wrapper form="vm.form">
                <form-row error="vm.form.errors.name">
                    <label class="label">{{ 'sites.Name' | translate }} *</label>
                    <div class="items">
                        <input ng-model="vm.form.model.name" type="text" class="form-control">
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                 <form-row error="vm.form.errors.isExternalSite">
                    <span class="label">{{ 'sites.External' | translate }}</span>
                    <div class="items">
                        <ul class="checkboxes">
                            <li><label><input ng-model="vm.form.model.isExternalSite" type="checkbox"> {{ 'general.Yes' | translate }}</label></li>
                            <form-row-error></form-row-error>
                        </ul>
                    </div>
                </form-row>
                <form-row ng-if="vm.TokenService.isTrainingCompany()" error="vm.form.errors.parentId">
                    <span class="label">{{ 'sites.Parent site' | translate }}</span>
                    <div class="items">
                        <div
                             ng-dropdown-multiselect=""
                             options="vm.parentMultiselect.parentSitesOptions"
                             selected-model="vm.parentMultiselect.selectedParent"
                             extra-settings="vm.parentMultiselect.parentSitesSettings"
                             events="vm.parentMultiselect.events"
                        ></div>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
            </form-wrapper>
            <ul class="actions01">
                <li class="primary">
                    <a ng-click="vm.save()" class="btn main">
                        <span ng-if="!vm.site.id">{{ 'general.Add' | translate }}</span>
                        <span ng-if="vm.site.id">{{ 'general.Save changes' | translate }}</span>
                    </a></li>
                <li><a ng-click="vm.cancel()" class="btn discrete">{{ 'general.Cancel' | translate }}</a></li>
            </ul>
            <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
        </form>
    `
})
export default class {
    constructor ($state, $scope, $translate, FormFactory, SiteResource, SiteParentService, ModalService, TokenService) {
        this.$state = $state;
        this.$scope = $scope;
        this.$translate = $translate;
        this.FormFactory = FormFactory;
        this.SiteResource = SiteResource;
        this.SiteParentService = SiteParentService;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.site);

        this.initMultiselect();

        this.parentMultiselect.parentSitesOptions = this.SiteParentService.mapSelectItems(this.tree, 0, this.site);
        this.parentMultiselect.parentSitesOptions.forEach((option) => {
            if (option.id === this.site.parentId) {
                this.parentMultiselect.selectedParent.push(option);
            }
        });
    }

    initMultiselect () {
        this.parentMultiselect = {
            selectedParent: [],
            parentSitesOptions: [],
            parentSitesSettings: {
                enableSearch: true,
                checkBoxes: false,
                showCheckAll: false,
                showUncheckAll: false,
                smartButtonMaxItems: 20,
                selectionLimit: 1,
                smartButtonTextConverter: (itemText) => itemText
            }
        };
    }

    beforeSave () {
        if (this.parentMultiselect.selectedParent.length) {
            this.form.model.parentId = this.parentMultiselect.selectedParent[0].id;
        }
        else {
            this.form.model.parentId = null;
        }
    }

    save () {
        this.beforeSave();
        this.doSave();
    }

    doSave () {
        if (!this.TokenService.isTrainingCompany()) {
            delete this.form.model.parentId;
        }

        this.form.save().then((model) => {
            this.$scope.$emit('token:refresh');
            this.$state.go('authorized.manage.permissions.sites.detail', { id: model.id });
        });
    }

    cancel () {
        if (this.site.id) {
            this.$state.go('authorized.manage.permissions.sites.detail', { id: this.site.id });
        }
        else {
            this.$state.go('authorized.manage.permissions.sites.list');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/sites/form/index.js